// Next Imports
import Link from "next/link";
import Image from "next/image";

//  MUI Imports
import {
  Box,
  Card,
  CardContent,
  Grid2 as Grid,
  Typography,
} from "@mui/material";

function CategoryCard({
  slug,
  topic,
  title,
  author,
  date,
  topicSlug,
  articleImage,
  headingLevel = "h2",
}) {
  return (
    <Card
      spacing={3}
      sx={{ borderRadius: "10px", marginBottom: "15px" }}
      component={"article"}
    >
      <Link href={`/blog/article/${slug}`} legacyBehavior>
        <CardContent
          sx={{
            paddingBottom: "0px",
            padding: { xs: "10px !important", sm: "20px" },
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          <Grid container spacing={{ xs: 1.5, sm: 3 }}>
            <Grid size={{ xs: 5 }}>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: { xs: "130px", sm: "180px" },
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <Image
                  src={articleImage ?? "/software_development_fallback.webp"}
                  alt={title}
                  fill
                  style={{
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  quality={50}
                  priority
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 7 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Box>
                  <Box
                    component={Link}
                    href={`/blog/topic/${topicSlug}`}
                    sx={{
                      backgroundColor: "#EDF2F7",
                      padding: { xs: "5px 10px", sm: "5px 15px" },
                      borderRadius: "5px",
                      width: "auto",
                      display: "inline-flex",
                      justifyContent: "center",
                      marginBottom: { xs: "10px", sm: "15px" },
                      marginTop: { xs: "10px", md: "20px" },
                      textDecoration: "none",
                      cursor: "pointer",
                      color: "#7F8DA1",
                      "&:hover": {
                        color: "#ffffff",
                        backgroundColor: "#718096",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: { xs: 600 },
                        fontSize: { xs: "10px", sm: "12px" },
                      }}
                    >
                      {topic}
                    </Typography>
                  </Box>
                  <Typography
                    component={headingLevel}
                    variant="h5"
                    sx={{
                      color: "#2D3748",
                      marginRight: "8px",
                      fontSize: { xs: "17px", sm: "20px" },
                      fontWeight: 600,
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      lineHeight: 1.3,
                    }}
                  >
                    {title}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    marginTop: "auto",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    component={"p"}
                    variant="h5"
                    sx={{
                      // fontSize: { xs: "34px", lg: "45px" },
                      color: "rgb(113, 128, 150)",
                      fontSize: "12px",
                      fontWeight: 700,
                      marginBottom: "5px",
                    }}
                  >
                    {author}
                  </Typography>
                  <Typography
                    component={"p"}
                    variant="h5"
                    sx={{
                      display: { xs: "none", sm: "block" },
                      // fontSize: { xs: "34px", lg: "45px" },
                      color: "rgb(160, 174, 192)",
                      fontSize: "14px",
                      fontWeight: 400,
                    }}
                  >
                    {date.split("T")[0]}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Link>
    </Card>
  );
}

export default CategoryCard;
